export const STATUS_ACTION_WIDTH = '4.25rem'
